// SPDX-License-Identifier: AGPL-3.0-or-later

import {ScheduledSettingsTab} from '@app/features/konvo_scheduled/components/ScheduledSettingsLink';

// KONVO: automations are managed on the Scheduled page. UserSettingsModal hands this tab over to
// /scheduled?filter=automations as soon as it opens; this is what shows for that moment.
export default function KonvoAssistantAutomationsTab() {
	return <ScheduledSettingsTab />;
}
